const useAuthTelegramDto = async (payload: TelegramPayload) => {
  const response = await useFetchData<FetchData<AuthToken>>("/auth/telegram", {
    body: payload,
    method: "POST",
  });

  return {
    ...response,
  };
};

export { useAuthTelegramDto };
